import { createContext, useContext } from "react";
import useTwilioDevice from "../hooks/useTwilioDevice";
import { useAuth } from "./AuthContext";

const TwilioContext = createContext(null);

export const TwilioProvider = ({ children }) => {
  const { user } = useAuth();
  // API / legacy data may use spaces or different casing
  const role = String(user?.role || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  const canUseCalling =
    role === "agent" ||
    role === "team_leader" ||
    role === "owner" ||
    role === "front_desk";
  const authUserId = user?._id != null ? String(user._id) : "";
  const twilio = useTwilioDevice(canUseCalling, authUserId);
  return (
    <TwilioContext.Provider value={twilio}>{children}</TwilioContext.Provider>
  );
};

export const useTwilio = () => {
  const ctx = useContext(TwilioContext);
  if (!ctx) {
    throw new Error("useTwilio must be used within a TwilioProvider");
  }
  return ctx;
};

export default TwilioContext;
